import { DEFAULT_ADVANCE_BUTTON_STYLE } from '../../../utils/styleHelpers';

export interface DownloadExcelButtonProps {
  sheetCount: number;
  disabled: boolean;
  onDownload: () => void;
}

/** The Download Excel button; it names the sheet count once there is more than one. */
export const DownloadExcelButton = ({ sheetCount, disabled, onDownload }: DownloadExcelButtonProps) => (
  <button
    type="button"
    className={DEFAULT_ADVANCE_BUTTON_STYLE}
    disabled={disabled}
    data-cy="report-download-excel"
    onClick={onDownload}>
    {sheetCount > 1 ? `Download Excel (${sheetCount} sheets)` : 'Download Excel'}
  </button>
);
